import { useEffect } from "react";
import { isTouchDisplay } from "~/const/device";
import { isSafari } from "~/lib/navigator/user-agent";

/**
 *  Note: bfcacheを利用してページを表示する場合、変数などすべてがcacheされているため、
 *  useEffect内の依存関数が更新されず、バグの発生理由になるのでreloadする。
 * */
export const useReloadOnBFCache = () => {
  useEffect(() => {
    // Note: bfcacheを利用してページを表示する可能性のあるブラウザ、OS
    if (!(isSafari() || isTouchDisplay)) return;
    const onShowHandler = (e: PageTransitionEvent) => {
      if (e.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener("pageshow", onShowHandler);

    return () => {
      window.removeEventListener("pageshow", onShowHandler);
    };
  }, []);
};
